import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Snackbar from "@mui/material/Snackbar";
import { IQuickAlert } from "../../interfaces/IQuickAlert";

export default function QuickAlert({
  description,
  title,
  severity = "success",
  visibility = false,
  hanhleClose,
}: IQuickAlert) {
  const handleClose = () => {
    hanhleClose && hanhleClose();
  };

  return (
    <Snackbar
      open={visibility}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      sx={{ top: { xs: 80, sm: 80 } }}
    >
      <Alert
        severity={severity}
        variant="standard"
        onClose={handleClose}
        sx={{ width: "25rem", borderRadius: "4px" }}
      >
        {title && <AlertTitle>{title}</AlertTitle>}
        {description}
      </Alert>
    </Snackbar>
  );
}
